import React, { useEffect, useState } from "react";
import { Row, Input, Form, Select, Col, Spin, Radio, Button } from "antd";

import { FONT, ROLE_ADMIN, ROLE_ADMIN_CUSTOMER } from "constants/index";
import { getUsers } from "services/user/user-service";
import { notificationErroInternal } from "util/api-utils";

const BranchDrawerForm = ({ form, editId, loadingDrawer }) => {
  const [loadingCustomers, setLoadingCustomers] = useState(false);
  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    getcustomers();
  }, []);

  const getcustomers = async () => {
    setLoadingCustomers(true);
    try {
      const users = await getUsers();
      const customerOptions = users
        .filter(
          (item) => item.role == ROLE_ADMIN_CUSTOMER || item.role == ROLE_ADMIN
        )
        .map((item) => ({
          label: item.name,
          value: item.id,
        }));
      setCustomers(customerOptions);
    } catch (error) {
      notificationErroInternal(
        "Aconteceu um erro inesperado, por favor, tente mais tarde."
      );
    } finally {
      setLoadingCustomers(false);
    }
  };

  return (
    <Spin spinning={loadingCustomers || loadingDrawer}>
      <Form form={form} layout="vertical">
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item
              name="name"
              label={<span style={{ fontFamily: FONT }}>Nome</span>}
              rules={[
                { required: true, message: "É necessário informar o nome" },
              ]}
            >
              <Input style={{ fontFamily: FONT }} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              name="role"
              label={<span style={{ fontFamily: FONT }}>Tipo</span>}
              rules={[
                { required: true, message: "É necessário informar o tipo" },
              ]}
            >
              <Select
                showSearch
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                style={{ width: "100%" }}
                options={[
                  {
                    value: "ESPORTIVO",
                    label: "Centro Esportivo",
                  },
                  {
                    value: "AQUATICO",
                    label: "Centro Aquático",
                  },
                ]}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item
              name="owner"
              label={<span style={{ fontFamily: FONT }}>Administrador</span>}
              rules={[
                {
                  required: true,
                  message: "É necessário informar o administrador",
                },
              ]}
            >
              <Select
                disabled={editId !== null}
                showSearch
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                style={{ width: "100%" }}
                options={customers}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              name="hasPhotocell"
              label={
                <span style={{ fontFamily: FONT }}>Possui Fotocélula?</span>
              }
            >
              <Radio.Group>
                <Radio value={true}>Sim</Radio>
                <Radio value={false}>Não</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16} style={{ padding: 2, paddingTop: 10 }}>
          <Col xs={24} md={12}>
            <Form.Item
              name="evoUser"
              label={<span style={{ fontFamily: FONT }}>Usuário Evo</span>}
            >
              <Input style={{ fontFamily: FONT }} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              name="evoPass"
              label={<span style={{ fontFamily: FONT }}>Senha Evo</span>}
            >
              <Input.Password style={{ fontFamily: FONT }} />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16} style={{ padding: 2, paddingTop: 10 }}>
          <Col span={24}>
            <Form.List name="webhooks">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <Row key={key} gutter={16} style={{ marginBottom: 16 }}>
                      <Col span={24}>
                        <Form.Item
                          {...restField}
                          name={[name, "webhook"]}
                          label={
                            <span style={{ fontFamily: FONT }}>Webhook</span>
                          }
                          rules={[
                            {
                              required: true,
                              message: "Informe a URL do webhook",
                            },
                            { type: "url", message: "Informe uma URL válida" },
                          ]}
                        >
                          <Input style={{ fontFamily: FONT }} />
                        </Form.Item>
                      </Col>

                      <Col span={24}>
                        <Form.Item
                          {...restField}
                          name={[name, "eventList"]}
                          label={
                            <span style={{ fontFamily: FONT }}>
                              Eventos Webhook
                            </span>
                          }
                          rules={[
                            {
                              required: true,
                              message: "Selecione pelo menos um evento",
                            },
                          ]}
                        >
                          <Select
                            mode="multiple"
                            showSearch
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                              (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            style={{ width: "100%" }}
                            options={[
                              { label: "Próximo Nível", value: "NEXT_LEVEL" },
                              { label: "Próxima Fase", value: "NEXT_PHASE" },
                              {
                                label: "Objetivo Concluído",
                                value: "OBJECTIVE_DONE",
                              },
                            ]}
                          />
                        </Form.Item>
                      </Col>

                      <Col
                        span={4}
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <Button
                          type="primary"
                          danger
                          onClick={() => remove(name)}
                          style={{ fontFamily: FONT }}
                        >
                          Remover
                        </Button>
                      </Col>
                    </Row>
                  ))}

                  <Form.Item>
                    <Button
                      type="primary"
                      onClick={() => add()}
                      style={{ fontFamily: FONT }}
                    >
                      Adicionar Webhook
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </Col>
        </Row>
      </Form>
    </Spin>
  );
};

export default BranchDrawerForm;
